import { ITipDetail } from 'capability-ng-todos';
import { PathTask } from 'capability-ng-todos';

export class MyTodoTipDetailController {
  private task: PathTask;

  constructor(
    private pathTipDetail: ITipDetail,
    private $state: ng.ui.IStateService,
    private TaskStatusEnum: any,
    private taskUpdateFn: any
  ) {
    this.task = this.pathTipDetail.source.task;
  }

  toggleDismissed(): void {
    const initialStatus = this.task.status;
    this.task.status = this.taskUpdateFn.getNewStatusAsString(this.task, initialStatus, true);

    this.taskUpdateFn.toggleDismissed(this.task, initialStatus).then(
      (updatedTip: PathTask) => {
        this.pathTipDetail.source.task = updatedTip;
        if (this.TaskStatusEnum.isEqual(updatedTip.status, this.TaskStatusEnum.DISMISSED)) {
          this.$state.go('my.todos');
        }
      },
      (err: any) => {
        this.pathTipDetail.source.task.status = initialStatus;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todo_tip_details/my_todo_tip_details_controller.ts